import ApiService from '@/api';
import {
  CheckTaskExistResultModel,
  GetWeeekTaskModel,
  WeeekTaskCheckExistsRequestModel,
} from '../models';
import { ResponseModel } from '@/models';
import { TaskImportDataModel } from '@/components/task-forms/models';
import {
  mapCheckExistRequest,
  mapCheckExistResponse,
  mapGetWeeekTaskRequest,
  mapGetWeeekTaskResponse,
} from './AdapterServiceMappers';

export class AdapterService {
  private api = new ApiService();

  /**Получить информацию о задаче из weeek для импорта */
  getWeeekTask(request: GetWeeekTaskModel): Promise<ResponseModel<TaskImportDataModel>> {
    return new Promise<ResponseModel<TaskImportDataModel>>(async (resolve) => {
      const result = new ResponseModel<TaskImportDataModel>();

      this.api.Weeek.WeeekTaskWsController.getAsync(mapGetWeeekTaskRequest(request))
        .then((resp) => {
          result.Value = mapGetWeeekTaskResponse(resp);
          resolve(result);
        })
        .catch((error) => {
          result.IsSuccess = false;
          result.ErrorCode = error.ErrorCode;
          result.ErrorMessage = error.ErrorMessage;
          console.error('ERROR getWeeekTask', error);
          resolve(result);
        });
    });
  }

  /**
   * Проверка наличия задачи
   * @param weeekTaskId
   * @returns
   */
  checkTaskExist(response: WeeekTaskCheckExistsRequestModel) {
    return new Promise<ResponseModel<CheckTaskExistResultModel>>(async (resolve) => {
      const result = new ResponseModel<CheckTaskExistResultModel>();

      await this.api.Weeek.WeeekTaskWsController.checkExistAsync(mapCheckExistRequest(response))
        .then((resp) => {
          result.Value = mapCheckExistResponse(resp);
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e.ErrorCode;
          result.ErrorMessage = e.ErrorMessage;
          console.error('ERROR checkTaskExist', e);
          resolve(result);
        });
    });
  }
}
